import { Grid, Typography } from '@mui/material'
import { Link, useNavigate } from 'react-router-dom'
import styles from './signup.module.scss'
import { useState } from 'react'
import { forgotPassword } from '../../features/authSlice'
import InputCustom from '../atoms/input/InputCustom.jsx'
import { CooldownButton } from '../buttons/CooldownButton.jsx'

const ForgotPwForm = () => {
	const [email, setEmail] = useState('')
	const navigate = useNavigate()
	return (
		<form className={styles.form} onSubmit={(e) => e.preventDefault()}>
			<div className={styles.formGroup}>
				<InputCustom
					autoFocus={true}
					required={true}
					type="email"
					placeholder="Email Address"
					name="email"
					onChange={(e) => setEmail(e.target.value.toLowerCase())}
				/>
			</div>

			<div className={`${styles.skipBtn}`}>
				<span
					to="/forgot-password"
					data-cy="go-to-forgot-password"
					className={styles.forgotPassword}
					onClick={() => navigate(-1)}
				>
					Back{' '}
				</span>
				<CooldownButton
					dispatchFunction={forgotPassword}
					dispatchData={email}
					buttonText="Send reset link"
					cooldownSeconds={15}
				/>
			</div>
		</form>
	)
}

export default ForgotPwForm
